import React from 'react';

// App-level error boundary. Catches render/runtime errors in the tree and
// shows a recoverable fallback instead of a blank white screen.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught an error:', error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="min-h-screen flex items-center justify-center bg-gray-50 p-6"
          data-testid="app-error-boundary"
        >
          <div className="max-w-md w-full bg-white border border-gray-200 rounded-xl shadow-sm p-8 text-center">
            <div className="text-lg font-semibold text-gray-900 mb-2">Something went wrong</div>
            <p className="text-sm text-gray-600 mb-6">
              An unexpected error occurred. You can reload the page to continue.
            </p>
            {this.state.error?.message && (
              <pre className="text-left text-xs bg-gray-100 text-gray-700 rounded p-3 mb-6 overflow-auto max-h-40 whitespace-pre-wrap">
                {String(this.state.error.message)}
              </pre>
            )}
            <button
              type="button"
              onClick={this.handleReload}
              className="inline-flex items-center justify-center rounded-md bg-gradient-to-r from-orange-500 to-amber-600 text-white text-sm font-medium px-4 py-2 hover:opacity-90 transition-opacity"
              data-testid="app-error-reload-btn"
            >
              Reload page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
